export enum ScorecardStatus {
  Draft = "Draft",
  Submitted = "Submitted",
}
